document.addEventListener("DOMContentLoaded", () => {
    const wrappers = document.querySelectorAll(".swipe-scroll-wrapper[id^='vayu-blocks-']");
    wrappers.forEach((wrapper) => {
        initSwipeFeatureSlider(wrapper);
    });
});

function initSwipeFeatureSlider(wrapper) {
    const block = wrapper.closest("[id^='vayu-blocks-']");
    if (!block) return;

    const carousel = block.querySelector(".swipe-carousel");
    const nav = carousel?.getAttribute("data-nav") || "none";

    if (!carousel || !wrapper) {
        console.log("Missing elements in:", block.id);
        return;
    }

    let items = Array.from(carousel.querySelectorAll(".slide-item"));
    if (items.length === 0) return;

    let btnLeft, btnRight;
    if (nav === 'arrow' || nav === 'arrowdots') {
        btnLeft = block.querySelector(".scroll-button.left");
        btnRight = block.querySelector(".scroll-button.right");
    }

    let paginationContainer = block.querySelector(".pagination-container");
    if (!paginationContainer && nav !== "none" && nav !== "arrow") {
        paginationContainer = document.createElement("div");
        paginationContainer.classList.add("pagination-container");
        wrapper.appendChild(paginationContainer);
    }

    let elementWidth = items[0].offsetWidth + 18;
    let visibleItems = Math.floor(wrapper.offsetWidth / elementWidth) || 1;
    let currentIndex = 0;
    let isDragging = false;
    let startPos = 0;
    let currentTranslate = 0;
    let prevTranslate = 0;
    let dragThreshold = elementWidth * 0.3;

    // Prevent image dragging
    items.forEach((item) => {
        const images = item.querySelectorAll("img");
        images.forEach((img) => {
            img.setAttribute("draggable", "false");
            img.addEventListener("dragstart", (e) => e.preventDefault());
        });
    });

    // Add clones for infinite scroll
    const clones = items.slice(0, visibleItems).map((item) => {
        const clone = item.cloneNode(true);
        clone.classList.add("clone");
        const cloneImages = clone.querySelectorAll("img");
        cloneImages.forEach((img) => {
            img.setAttribute("draggable", "false");
            img.addEventListener("dragstart", (e) => e.preventDefault());
        });
        return clone;
    });

    clones.forEach((clone) => carousel.appendChild(clone));
    items = Array.from(carousel.querySelectorAll(".slide-item"));

    // Setup pagination dots
    if (paginationContainer) {
        paginationContainer.innerHTML = '';
        items.slice(0, items.length - clones.length).forEach((_, index) => {
            const dot = document.createElement("span");
            dot.classList.add("pagination-dot");
            dot.dataset.index = index;
            paginationContainer.appendChild(dot);
        });
    }

    const updatePagination = () => {
        const realIndex = currentIndex % (items.length - clones.length);
        if (paginationContainer) {
            paginationContainer.querySelectorAll(".pagination-dot").forEach((dot, index) => {
                dot.classList.toggle("active", index === realIndex);
            });
        }
    };

    const scrollToIndex = (index, animate = true) => {
        currentIndex = index;

        // Looping logic
        if (currentIndex >= items.length - clones.length) {
            currentIndex = 0;
            currentTranslate = 0;
        } else if (currentIndex < 0) {
            currentIndex = items.length - clones.length - 1;
            currentTranslate = -currentIndex * elementWidth;
        }

        currentTranslate = -currentIndex * elementWidth;
        prevTranslate = currentTranslate;
        carousel.style.transform = `translateX(${currentTranslate}px)`;
        carousel.style.transition = animate ? "transform 0.4s ease" : "none";

        updatePagination();
    };

    // Drag functionality
    const getPositionX = (event) => {
        return event.type.includes("mouse") ? event.clientX : event.touches[0].clientX;
    };

    const dragStart = (event) => {
        if (event.type === "touchstart") {
            event.preventDefault();
        }
        isDragging = true;
        startPos = getPositionX(event);
        prevTranslate = currentTranslate;
        carousel.style.transition = "none";
        carousel.classList.add("dragging");
    };

    const dragMove = (event) => {
        if (!isDragging) return;
        const currentPosition = getPositionX(event);
        const diff = currentPosition - startPos;
        currentTranslate = prevTranslate + diff;

        const maxTranslate = 0;
        const minTranslate = -((items.length - visibleItems) * elementWidth);
        if (currentTranslate > maxTranslate) {
            currentTranslate = maxTranslate + (currentTranslate - maxTranslate) * 0.5;
        } else if (currentTranslate < minTranslate) {
            currentTranslate = minTranslate + (currentTranslate - minTranslate) * 0.5;
        }

        carousel.style.transform = `translateX(${currentTranslate}px)`;
    };

    const dragEnd = () => {
        if (!isDragging) return;
        isDragging = false;
        carousel.classList.remove("dragging");

        const movedBy = currentTranslate - (-currentIndex * elementWidth);
        let newIndex = currentIndex;

        if (Math.abs(movedBy) > dragThreshold) {
            newIndex += movedBy > 0 ? -1 : 1;
        }

        scrollToIndex(newIndex);
    };

    // Event listeners for dragging
    carousel.addEventListener("mousedown", dragStart);
    carousel.addEventListener("touchstart", dragStart, { passive: false });
    carousel.addEventListener("mousemove", dragMove);
    carousel.addEventListener("touchmove", dragMove, { passive: false });
    carousel.addEventListener("mouseup", dragEnd);
    carousel.addEventListener("touchend", dragEnd);
    carousel.addEventListener("mouseleave", () => {
        if (isDragging) dragEnd();
    });

    // Prevent click events after significant drag
    carousel.addEventListener(
        "click",
        (e) => {
            if (Math.abs(currentTranslate - prevTranslate) > 10) {
                e.preventDefault();
                e.stopPropagation();
            }
        },
        true
    );

    // Arrow buttons
    if (btnLeft) {
        btnLeft.addEventListener("click", () => scrollToIndex(currentIndex - 1));
    }
    if (btnRight) {
        btnRight.addEventListener("click", () => scrollToIndex(currentIndex + 1));
    }

    // Pagination dots
    if (paginationContainer) {
        paginationContainer.addEventListener("click", (e) => {
            if (e.target.classList.contains("pagination-dot")) {
                scrollToIndex(parseInt(e.target.dataset.index, 10));
            }
        });
    }

    // Initial setup
    carousel.style.willChange = "transform";
    carousel.style.transform = `translateX(0px)`;

    // Handle window resize
    const handleResize = () => {
        elementWidth = items[0]?.offsetWidth + 18 || 0;
        visibleItems = Math.floor(wrapper.offsetWidth / elementWidth) || 1;
        dragThreshold = elementWidth * 0.3;
        scrollToIndex(currentIndex, false);
    };
    window.addEventListener("resize", handleResize);

    updatePagination();
}